import React, { useEffect, useState } from "react";
import { addMatterTask, updateMatterTask } from "api/index";
import styles from "./Casefile.module.scss";
import { Dialog, DialogActionsBar } from "@progress/kendo-react-dialogs";
import { FormComboBox, FormDate } from "components/Matters/index";
import { TimePicker } from "@progress/kendo-react-dateinputs";
import { Label } from "@progress/kendo-react-labels";
import { Checkbox } from "@progress/kendo-react-inputs";
import { CONSTANT } from "CONSTANT/Matter/MatterActivityForm";
import { TextArea } from "@progress/kendo-react-inputs";
import { Button } from "@progress/kendo-react-buttons";
import { filterBy } from "@progress/kendo-data-query";
import { Tile } from "components/UIComponents/Tile";

import { useActiveFeeEarner } from "services/userService";
import SubmitButton from "components/common/SubmitButton";
import { formatTime } from "components/common/formatter";

const CaseTaskForm = (props) => {
    const [dateState, setDateState] = useState(new Date());
    const [dueDateState, setDueDateState] = useState(() => {
        const currentDate = new Date();
        currentDate.setDate(currentDate.getDate() + 7);
        return currentDate;
    });
    const [isDueDateChecked, setIsDueDateChecked] = useState(false);
    const [isDueTimeChecked, setIsDueTimeChecked] = useState(false);
    const [details, setDetails] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [comboBoxState, setComboBoxState] = useState({
        [CONSTANT.COMBOBOX.TYPE]: "",
        [CONSTANT.COMBOBOX.FEE_EARNER]: "",
    });
    const { data: feeEarnerData, loading } = useActiveFeeEarner();
    const [feeEarner, setFeeEarner] = useState([]);
    const [dueTimeState, setDueTimeState] = useState(null);

    useEffect(() => {
        if (feeEarnerData && feeEarnerData.length > 0) {
            setFeeEarner(feeEarnerData);
            if (props.viewTask) {
                const selectedFeeEarner = feeEarnerData.find(
                    (item) => item.userRef === props?.viewTask?.feeEarnerRef
                );
                if (selectedFeeEarner) {
                    handleComboBoxChange(
                        { value: selectedFeeEarner },
                        CONSTANT.COMBOBOX.FEE_EARNER
                    );
                }
            }
            else if (props?.feeEarnerRef) {
                const selectedFeeEarner = feeEarnerData.find(
                    (item) => item.userRef === props?.feeEarnerRef
                );
                if (selectedFeeEarner) {
                    handleComboBoxChange(
                        { value: selectedFeeEarner },
                        CONSTANT.COMBOBOX.FEE_EARNER
                    );
                }
            }
        }
    }, [feeEarnerData?.length, props?.feeEarnerRef]);

    useEffect(() => {
        if (props.isView) {
            getEditData();
        }
    }, [props.isView]);


    const filterFeeEarner = (filter) => {
        const data = feeEarnerData?.slice() || [];
        return filterBy(data, filter);
    };
    const feeEarnerfilterChange = (event) => {
        setFeeEarner(filterFeeEarner(event.filter));
    };

    const handleComboBoxChange = (e, label) =>
        setComboBoxState((prevState) => ({
            ...prevState,
            [label]: e.value,
        }));

    const handleDateChange = (e) => setDateState(e.value);

    const handleDueDateChange = (e) => {
        if (e.value) {
            setDueDateState(e.value);
            setIsDueDateChecked(true);
        } else {
            setDueDateState(null);
            setIsDueDateChecked(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);

        const parseDate = (newDate) => {
            if (!newDate) return null;
            var os = newDate?.getTimezoneOffset();
            return (newDate = new Date(newDate.getTime() - os * 60 * 1000));
        };

        const dataObject = {
            date: parseDate(dateState) || null,
            ...(isDueDateChecked && { dateDueBy: parseDate(dueDateState) }),
            ...(isDueDateChecked &&
                dueDateState &&
                (isDueTimeChecked && dueTimeState
                    ? { timeDueBy: formatTime(dueTimeState) }
                    : { timeDueBy: null })),
            feeEarnerRef:
                comboBoxState[CONSTANT.COMBOBOX.FEE_EARNER]?.userRef || null,
            details: details,
            type: "FeeEarnerTask",
        };
        try {
            const res = props.isView
                ? await updateMatterTask(props?.viewTask?.taskId, dataObject)
                : await addMatterTask(props?.matterId, dataObject);

            if (res.status === 200) {
                props?.setIsRefreshed(!props?.isRefreshed);
                props?.setCloseModal();
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const getEditData = async () => {
        setDetails(props.viewTask?.details);
        setDateState(new Date(props.viewTask?.date));
        setIsDueDateChecked(props.viewTask?.dateDueBy ? true : false);
        props.viewTask?.dateDueBy &&
            setDueDateState(new Date(props.viewTask?.dateDueBy));
        if (props.viewTask?.timeDueBy) {
            setIsDueTimeChecked(true);
            const [hours, minutes, seconds = 0] = props.viewTask.timeDueBy
                .split(":")
                .map(Number);
            const timeDate = new Date();
            timeDate.setHours(hours, minutes, seconds, 0);
            setDueTimeState(timeDate);
        }
    };

    const handleCheckboxChange = (e) => {
        setIsDueDateChecked(e.value);
        if (e.value && !dueDateState) {
            const nextWeek = new Date();
            nextWeek.setDate(nextWeek.getDate() + 7);
            setDueDateState(nextWeek);
        }
    };

    const handleDueTimeChange = (e) => {
        setDueTimeState(e.value);
        setIsDueTimeChecked(true);
    };

    const handleDueTimeCheckboxChange = (e) => {
        setIsDueTimeChecked(e.value); if (!dueTimeState) {
            const now = new Date();
            setDueTimeState(now);
        }
    };

    return (
        <div>
            <Dialog
                title={props.isView ? "Update Task" : "Add Task"}
                onClose={props?.setCloseModal}
                className="dialog-sm"
            >
                <div className="d-flex flex-column w-100 h-100">

                    <form id="taskForm" onSubmit={handleSubmit} className="flex-grow-1 h-100">
                        <div className="row g-0 h-100">

                            <div className=" bgForm py-4 px-5 col-5 overflow-auto"
                                style={{ minWidth: "350px", maxWidth: "350px" }}
                            >

                                <div className="d-flex flex-column ">
                                    <div className="">
                                        <span className={`${styles["add-activity-form-text"]}`}>
                                            {props.addFormText}
                                        </span>
                                    </div>
                                    <FormDate
                                        isStyled={true}
                                        className="col-12 mt-3"
                                        label={"Date"}
                                        onChangeDate={handleDateChange}
                                        state={{ Date: dateState }}
                                    />
                                    <FormComboBox
                                        required={true}
                                        isStyled={true}
                                        className="col-12 mt-4"
                                        //   width={"260px"}
                                        wf={true}
                                        onChangeComboBox={handleComboBoxChange}
                                        onFilterChange={feeEarnerfilterChange}
                                        data={feeEarner}
                                        textField="display"
                                        state={comboBoxState}
                                        name={CONSTANT.COMBOBOX.FEE_EARNER}
                                        loading={loading}
                                    />
                                    <FormDate
                                        isStyled={true}
                                        className="col-12 mt-3"
                                        label={"Due Date"}
                                        onChangeDate={handleDueDateChange}
                                        state={{
                                            "Due Date": isDueDateChecked ? dueDateState : null,
                                        }}
                                        checkbox
                                        checked={isDueDateChecked}
                                        handleCheckboxChange={handleCheckboxChange}
                                    />
                                    <div
                                        className={`col-12 mt-3 d-flex flex-column ${!isDueDateChecked || !dueDateState ? "opacity-50" : ""}`}
                                    >
                                        <Label className="label mb-1">Due Time</Label>
                                        <div className="date-form-to-wrapper">
                                            <Checkbox
                                                className="ms-2 mt-auto mb-auto"
                                                checked={isDueTimeChecked}
                                                onChange={handleDueTimeCheckboxChange}
                                                disabled={!isDueDateChecked || !dueDateState}
                                            />
                                            <TimePicker
                                                className="date-picker w-100 px-2"
                                                disabled={!isDueDateChecked || !dueDateState}
                                                format="hh:mm a"
                                                style={{
                                                    width: "128px",
                                                    height: "20px",
                                                    fontSize: "15px",
                                                }}
                                                placeholder="Select Time"
                                                value={dueTimeState}
                                                onChange={handleDueTimeChange}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div className="col-6 mx-auto">
                                <Tile
                                    heading="Details"
                                    className="px-4 pb-3 my-3 w-100 overflow-auto"                                    
                                >
                                    <TextArea
                                        rows={10}
                                        required
                                        size="large"
                                        placeholder="Enter Details"
                                        autoSize={true}
                                        value={details}
                                        maxLength={256}
                                        style={{
                                            height: "32vh",
                                            maxWidth: "420px",
                                        }}
                                       
                                        onChange={(e) => setDetails(e.value)}
                                    />
                                </Tile>
                            </div>
                        </div>
                    </form>
                </div>

                <DialogActionsBar>
                    <div className="dialog-footer d-flex flex-wrap justify-content-end gap-2 ">
                        <Button
                            className="common-btn bgBtnSecondary border-0 me-2"
                            onClick={props?.setCloseModal}
                            disabled={isSubmitting}
                        >
                            Cancel
                        </Button>
                        <SubmitButton
                            className="me-4"
                            onClick={() => {
                                handleSubmit({ preventDefault: () => { } });
                            }}
                            isLoading={isSubmitting}
                            disabled={isSubmitting}
                        >
                            {props.isView ? "Update" : "Save"}
                        </SubmitButton>
                    </div>
                </DialogActionsBar>
              
            </Dialog>
        </div>
    );
};

export default CaseTaskForm;
